import localStorageAPIGet from "./localStorageAPIGet";
const PrechatMessagesGet = function (storageName) {
    var msgs = localStorageAPIGet('livechat_prechat_msg_array');
    if(!msgs) return null;
    
    return JSON.parse(msgs);
};
export default PrechatMessagesGet;
